var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["mku-drop", _vm.className],
      on: {
        mouseenter: function($event) {
          return _vm.$emit("mouseenter")
        },
        mouseleave: function($event) {
          return _vm.$emit("mouseleave")
        },
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }